import { Trans } from '@lingui/react'

import Notification from 'views/components/molecules/Notification'

export const ErxBonusNotUsedInfoNonDiscountable = ({
  searchUrl,
}: {
  searchUrl: string
}) => {
  return (
    <div
      className="u-margin--bottom u-border o-Cart-ErxNotification--Border"
      data-qa-id="show-erx-bonus-notUsed-info-nonDiscountable"
    >
      <Notification
        className="u-background-color--background"
        heading={
          <Trans
            id="cart.notification.prescriptionBonus.notUsed.nonDiscountable.headline"
            components={{ sup: <sup /> }}
          />
        }
        label={
          <div>
            <div className="u-margin-x-small--bottom">
              <ul className="u-no-padding u-padding-large--left">
                <Trans
                  id="cart.notification.prescriptionBonus.notUsed.nonDiscountable"
                  components={{ li: <li /> }}
                />
              </ul>
            </div>
            <a href={searchUrl} className="o-Cart-Notification-link">
              <Trans id="cart.notification.prescriptionBonus.notUsed.recommendations" />
            </a>
          </div>
        }
        type="warningNoBgColor"
      />
    </div>
  )
}
